import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
export const HowItWorks = () => {
  const steps = [{
    title: 'Configurás',
    desc: 'Optimizás tu perfil para generar autoridad inmediata en 1 hora.'
  }, {
    title: 'Conectás',
    desc: 'Aplicás el Método R.E.P. para iniciar conversaciones con clientes potenciales.'
  }, {
    title: 'Cobrás',
    desc: 'Recibís tus comisiones por cada cita agendada que se convierta en venta.'
  }];
  return <AnimatedSection data-id="element-60">
      <div className="mb-16 text-center" data-id="element-61">
        <span className="uppercase tracking-widest text-xs font-semibold text-ink/50 block mb-4" data-id="element-62">
          CÓMO FUNCIONA
        </span>
      </div>

      <div className="grid md:grid-cols-3 gap-12 relative" data-id="element-63">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[1px] bg-ink/10 z-0" data-id="element-64"></div>

        {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-65">
            <div className="w-24 h-24 bg-paper border border-ink/20 rounded-full flex items-center justify-center mb-6 shadow-sm" data-id="element-66">
              <span className="text-4xl font-serif text-accent" data-id="element-67">
                {index + 1}
              </span>
            </div>
            <h3 className="text-2xl font-serif text-ink mb-4" data-id="element-68">{step.title}</h3>
            <p className="font-sans text-ink/70 leading-relaxed max-w-xs" data-id="element-69">
              {step.desc}
            </p>
          </div>)}
      </div>
    </AnimatedSection>;
};